import React from 'react'
import NumberFormat from 'react-number-format'

const Index = ({shareholder, last}) => {

	return(
		<tr id={shareholder.id} className={last ? "bottom":""}>
			<td><span className="name">{shareholder.name ? shareholder.name:"Utilgjengelig"}</span></td>
			<td>{shareholder.organizationNumber ? <NumberFormat format={"### ### ###"} displayType="text" value={shareholder.organizationNumber}/>:"Utilgjengelig"}</td>
			<td>{shareholder.country ? shareholder.country:"Utilgjengelig"}</td>
            <td>{shareholder.share ? `${shareholder.share}%`:"Utilgjengelig"}</td>
		</tr>
	)
}

export default Index